import { render } from "./PortfolioCard.vue?vue&type=template&id=bf2605ee&scoped=true"
import script from "./PortfolioCard.vue?vue&type=script&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=bf2605ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2605ee"]])

export default __exports__